import { __spreadArrays } from "tslib";
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
var setupStore = function (rootReducer, initialState, middleware) {
    if (middleware === void 0) { middleware = []; }
    var allMiddleware = __spreadArrays([promiseMiddleware, thunk], middleware);
    var composeEnhancers = typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            name: 'chat-sdk'
        }) : compose;
    var enhancer = composeEnhancers(applyMiddleware.apply(void 0, allMiddleware));
    var store = createStore(rootReducer, initialState, enhancer);
    return store;
};
export default setupStore;
